export const Last20Years = Array.from({ length: 20 }, (_, index) =>
  (new Date().getFullYear() - index).toString()
);
export const Months = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

export const BlockRest = [
  "Quality and Safety Issues",
  "Chronic Order Delays",
  "Misrepresentation",
  "Violation of Platform Policies",
  "Illegal Activities",
];

export const BlockDriver = [
  "Consistent Order Delays",
  "Poor Customer Service",
  "Reckless Driving",
  "Fraudulent Activity",
  "Violation of Platform Policies",
];

export const CancelOrder = [
  "Payment Issues",
  "Unavailability of Items",
  "Delivery Address Inaccuracy",
  "Security or Fraud Concerns",
  "Violation of Platform Policies",
];

export const BlockSubAdmin = [
  "Violation of Company Policies",
  "Breach of Security Protocols",
  "Misuse of Administrative Privileges",
  "Failure to Fulfill Assigned Responsibilities",
  "Engagement in Unethical Behavior",
];

export const DeleteBanner = [
  "Expired Promotion or Event",
  "Incorrect Information",
  "Inappropriate Content",
  "Rebranding or Campaign Change",
  "Design or Layout Issues",
];

export const rolesOptions = [
  { name: "dashboard-management", label: "Dashboard Management" },
  { name: "customer-management", label: "Customer Management" },
  { name: "challenge-management", label: "Challenge Management" },
  { name: "user-challenge-management", label: "User Challenge Management" },
  { name: "feed-management", label: "Feed Management" },
  { name: "leaderboard-management", label: "Leaderboard Management" },
  { name: "category-management", label: "Category Management" },
  { name: "attribute-management", label: "Attribute Management" },
  { name: "product-management", label: "Product Management" },
  { name: "content-media-management", label: "Media Content Management" },
  { name: "coupon-management", label: "Coupon Management" },
  { name: "support-management", label: "Support Management" },
  { name: "order-management", label: "Order Management" },
  { name: "cms-management", label: "CMS Management" },
  { name: "email-template-management", label: "Email Template Management" },
  { name: "notifications", label: "Notification Management" },
];

export const attributeOption = [
  {
    label: "Dropdown",
    value: "dropdown",
  },
  {
    label: "Radio",
    value: "radio",
  },
  // {
  //   label: "Button",
  //   value: "button",
  // },
  // {
  //   label: "Checkbox",
  //   value: "checkbox",
  // },
  // {
  //   label: "Input Number",
  //   value: "inputNumber",
  // },
  // {
  //   label: "Calendar",
  //   value: "calendar",
  // },
  // {
  //   label: "Boolean",
  //   value: "boolean",
  // },
  {
    label: "Textbox",
    value: "textbox",
  },
];
